import { Component } from 'react';
import { connect } from 'react-redux';
import Honeybadger from '@honeybadger-io/js';
import * as redux from '../../../../redux';
import { IDError, IDSide } from 'kb-shared';

import { retrieveFile, CATEGORY } from '../../../../api/pf2/files';

const {
  patient: { updateSubmittedID, idError, resetIDError }
} = redux;

type Props = {
  updateSubmittedID: (hasSubmitted: boolean) => void;
  idError: (target: IDSide, error: IDError) => void;
  resetIDError: (target: IDSide) => void;
};

class InsuranceCardLoader extends Component<Props> {
  constructor(props: Props) {
    super(props);
    this.loadInsuranceCard();
  }

  loadInsuranceCard = () => {
    const { updateSubmittedID } = this.props;

    this.loader('front')
      .then(frontSuccess => {
        if (!frontSuccess) return;
        updateSubmittedID(true);
      })
      .catch(error => Honeybadger.notify(error));
  };

  loader = (target: 'front'): Promise<boolean> => {
    const { idError, resetIDError } = this.props;
    return new Promise(async resolve => {
      const errorMessage = { type: 'UnableToLoadFront' };

      try {
        const category = CATEGORY.ID_FRONT;
        const { file } = await retrieveFile(category);

        const image = new Image();
        image.src = file;
        image.onload = () => {
          resetIDError(target);
          resolve(true);
        };
        image.onerror = () => {
          idError(target, errorMessage);
          resolve(false);
        };
      } catch (error) {
        Honeybadger.notify(error);
        idError(target, errorMessage);
        resolve(false);
      }
    });
  };

  render() {
    return null;
  }
}

export default connect(null, dispatch => ({
  updateSubmittedID: (hasSubmitted: boolean) => dispatch(updateSubmittedID(hasSubmitted)),
  idError: (target: IDSide, error: IDError) => dispatch(idError(target, error)),
  resetIDError: (target: IDSide) => dispatch(resetIDError(target))
}))(InsuranceCardLoader);
